// Sample data based on the schemas
export function getSampleData() {
  return {
    "patient.admit": {
      meta: {
        messageId: "00000000-0000-0000-0000-000000000000",
        requestId: "11111111-1111-1111-1111-111111111111",
        when: new Date().toISOString(),
        type: "patient.admit" as const,
      },
      payload: {
        url: "https://s3.us-east-1.amazonaws.com/public.metriport.com/sandbox-data/patient-encounter-admit-bundle.json",
        patientId: "78a4d9e5-f2b3-42c8-9a84-52f3e21c2b9d",
        externalId: "123456",
        additionalIds: {
          athenahealth: ["99992"],
        },
        admitTimestamp: new Date().toISOString(),
      },
    },
    "patient.transfer": {
      meta: {
        messageId: "33333333-3333-3333-3333-333333333333",
        requestId: "44444444-4444-4444-4444-444444444444",
        when: new Date().toISOString(),
        type: "patient.transfer" as const,
      },
      payload: {
        url: "https://s3.us-east-1.amazonaws.com/public.metriport.com/sandbox-data/patient-encounter-transfer-bundle.json",
        patientId: "78a4d9e5-f2b3-42c8-9a84-52f3e21c2b9d",
        externalId: "123456",
        additionalIds: {
          athenahealth: ["99992"],
        },
        admitTimestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
        transfers: [
          {
            timestamp: new Date().toISOString(),
            sourceLocation: {
              name: "Emergency Room",
              type: "ER",
            },
            destinationLocation: {
              name: "Medical Ward 3",
              type: "WARD",
            },
          },
        ],
      },
    },
    "patient.discharge": {
      meta: {
        messageId: "55555555-5555-5555-5555-555555555555",
        requestId: "66666666-6666-6666-6666-666666666666",
        when: new Date().toISOString(),
        type: "patient.discharge" as const,
      },
      payload: {
        url: "https://s3.us-east-1.amazonaws.com/public.metriport.com/sandbox-data/patient-encounter-discharge-bundle.json",
        patientId: "78a4d9e5-f2b3-42c8-9a84-52f3e21c2b9d",
        externalId: "123456",
        additionalIds: {
          athenahealth: ["99992"],
        },
        admitTimestamp: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
        dischargeTimestamp: new Date().toISOString(),
      },
    },
  };
}
